import { useCurrentUserProfile } from 'hooks/queries/users/useCurrentUserProfile'
import { useEffect } from 'react'
import { AUTHED_SESSION_EVENT, trackEvent } from 'utils/trackingUtils'

export const GtmAuthTracker = () => {
  const { data: profile } = useCurrentUserProfile()

  useEffect(() => {
    if (profile) trackEvent(AUTHED_SESSION_EVENT, profile)
  }, [profile])

  return null
}
